import { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { clearAuthStorageIfTokenMalformed, readAccessToken } from "../authTokenUtils";
import { ensureFontGroup } from "../utils/ensureFonts";

const PrivateRoute = () => {
  clearAuthStorageIfTokenMalformed();
  const token = readAccessToken();
  // Dashboard / studio screens use Inter + Readex Pro; they used to come from @import rules in main.css,
  // which the public storefront also had to wait for. Loaded here instead, only for logged-in screens.
  useEffect(() => {
    if (token) ensureFontGroup("ui");
  }, [token]);
  return token ? <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;